document.addEventListener('DOMContentLoaded', function () {
  var wrap = document.querySelector('.sc-wrap');
  if (!wrap) return;

  var tabBtns = Array.prototype.slice.call(wrap.querySelectorAll('.sc-tabs .sc-tab-btn'));
  var panels = Array.prototype.slice.call(wrap.querySelectorAll('.sc-panel'));
  var vtBtns = Array.prototype.slice.call(wrap.querySelectorAll('.sc-view-toggle .sc-vt-btn'));
  var input = wrap.querySelector('#sc-foot-input');
  var hint = wrap.querySelector('#sc-finder-hint');
  var clearBtn = wrap.querySelector('#sc-finder-clear');

  var cardView = false;

  function parseFoot(text) {
    var m = text.replace(',', '.').match(/[\d.]+/);
    return m ? parseFloat(m[0]) : NaN;
  }

  function buildCards(panel) {
    var cardsBox = panel.querySelector('.sc-cards');
    var rows = panel.querySelectorAll('.sc-table-wrap tbody tr');
    if (!cardsBox || cardsBox.dataset.built) return;
    rows.forEach(function (row) {
      var tds = row.querySelectorAll('td');
      if (tds.length < 2) return;
      var card = document.createElement('div');
      card.className = 'sc-card';
      card.innerHTML =
        '<span class="sc-card-eu">' + tds[1].textContent.trim() + '</span>' +
        '<span class="sc-card-foot">' + tds[0].textContent.trim() + '</span>';
      cardsBox.appendChild(card);
    });
    cardsBox.dataset.built = '1';
  }
  panels.forEach(buildCards);

  function applyViewToPanel(panel) {
    var tableWrap = panel.querySelector('.sc-table-wrap');
    var cardsBox = panel.querySelector('.sc-cards');
    if (!tableWrap || !cardsBox) return;
    if (cardView) {
      tableWrap.style.display = 'none';
      cardsBox.style.display = 'flex';
    } else {
      tableWrap.style.display = '';
      cardsBox.style.display = 'none';
    }
  }

  function activePanel() {
    return panels[tabBtns.findIndex(function (b) { return b.classList.contains('active'); })] || panels[0];
  }

  function applyFinder() {
    var panel = activePanel();
    var rows = Array.prototype.slice.call(panel.querySelectorAll('.sc-table-wrap tbody tr'));
    var cards = Array.prototype.slice.call(panel.querySelectorAll('.sc-cards .sc-card'));

    rows.forEach(function (r) { r.classList.remove('sc-row-match'); });
    cards.forEach(function (c) { c.classList.remove('sc-card-match'); });

    var val = parseFloat(input.value);
    if (!input.value || isNaN(val)) {
      hint.textContent = '';
      clearBtn.style.display = 'none';
      return;
    }

    clearBtn.style.display = '';

    var bestIdx = -1, bestDiff = Infinity;
    rows.forEach(function (row, i) {
      var tds = row.querySelectorAll('td');
      if (!tds.length) return;
      var foot = parseFoot(tds[0].textContent);
      if (isNaN(foot)) return;
      var diff = Math.abs(foot - val);
      if (diff < bestDiff) {
        bestDiff = diff;
        bestIdx = i;
      }
    });

    if (bestIdx === -1) {
      hint.textContent = '';
      return;
    }

    rows[bestIdx].classList.add('sc-row-match');
    if (cards[bestIdx]) cards[bestIdx].classList.add('sc-card-match');

    var sizeText = rows[bestIdx].querySelectorAll('td')[1].textContent.trim();
    hint.textContent = 'המידה המתאימה לך: ' + sizeText;
  }

  tabBtns.forEach(function (btn, i) {
    btn.addEventListener('click', function () {
      tabBtns.forEach(function (b) { b.classList.remove('active'); });
      panels.forEach(function (p) { p.classList.remove('active'); });
      btn.classList.add('active');
      panels[i].classList.add('active');
      applyViewToPanel(panels[i]);
      applyFinder();
    });
  });

  vtBtns.forEach(function (btn, i) {
    btn.addEventListener('click', function () {
      vtBtns.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      cardView = i === 1;
      applyViewToPanel(activePanel());
    });
  });

  if (input) {
    input.addEventListener('input', applyFinder);
  }
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      applyFinder();
    });
  }

  applyViewToPanel(activePanel());
});
